import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../Themecontext/Themecontext";

export const NotFound = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isdark = theme;

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        height: "100%",
        minHeight: "calc(100vh - 57px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isdark === "light" ? "#f1f5f9" : "#0b0f19",
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(30px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes scaleSwing {
            0% { transform: rotate(-10deg); }
            50% { transform: rotate(10deg); }
            100% { transform: rotate(-10deg); }
          }
          @keyframes leftPan {
            0% { transform: rotate(10deg); }
            50% { transform: rotate(-10deg); }
            100% { transform: rotate(10deg); }
          }
          @keyframes rightPan {
            0% { transform: rotate(10deg); }
            50% { transform: rotate(-10deg); }
            100% { transform: rotate(10deg); }
          }
          
          /* Background Glow Orbs Animation */
          @keyframes driftOrb1 {
            0% { transform: translate(0px, 0px) scale(1); }
            33% { transform: translate(40px, -60px) scale(1.2); }
            66% { transform: translate(-30px, 30px) scale(0.85); }
            100% { transform: translate(0px, 0px) scale(1); }
          }
          @keyframes driftOrb2 {
            0% { transform: translate(0px, 0px) scale(1); }
            50% { transform: translate(-50px, 40px) scale(1.15); }
            100% { transform: translate(0px, 0px) scale(1); }
          }
          
          /* Floating Financial Symbols Animation */
          @keyframes floatSymbolFast {
            0% { transform: translateY(0px) rotate(0deg) scale(0.9); opacity: 0.1; }
            50% { transform: translateY(-25px) rotate(15deg) scale(1.1); opacity: 0.25; }
            100% { transform: translateY(0px) rotate(0deg) scale(0.9); opacity: 0.1; }
          }
          @keyframes floatSymbolSlow {
            0% { transform: translateY(0px) rotate(0deg) scale(1); opacity: 0.15; }
            50% { transform: translateY(20px) rotate(-15deg) scale(0.95); opacity: 0.3; }
            100% { transform: translateY(0px) rotate(0deg) scale(1); opacity: 0.15; }
          }
          @keyframes floatSymbolDrift {
            0% { transform: translate(0px, 0px) rotate(0deg); opacity: 0.1; }
            50% { transform: translate(15px, -15px) rotate(10deg); opacity: 0.25; }
            100% { transform: translate(0px, 0px) rotate(0deg); opacity: 0.1; }
          }

          /* Financial Grid Pulse */
          @keyframes gridPulse {
            0%, 100% { opacity: 0.03; }
            50% { opacity: 0.07; }
          }

          .floating-symbol {
            position: absolute;
            font-weight: 800;
            user-select: none;
            z-index: 1;
          }
          .go-back-btn {
            transition: all 0.3s ease;
          }
          .btn-primary-custom:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 25px -5px rgba(99, 102, 241, 0.4);
          }
          .btn-secondary-custom:hover {
            transform: translateY(-2px);
            background: ${isdark === "light" ? "#cbd5e1" : "#475569"} !important;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          }
          .go-back-btn:active {
            transform: translateY(1px);
          }
        `}
      </style>

      {/* Grid Pattern Background */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: isdark === "light"
            ? "linear-gradient(rgba(99, 102, 241, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(99, 102, 241, 0.1) 1px, transparent 1px)"
            : "linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
          zIndex: 0,
          animation: "gridPulse 4s ease-in-out infinite",
        }}
      />

      {/* Large Colorful Animated Light Orbs in Background */}
      <div
        style={{
          position: "absolute",
          top: "10%",
          left: "15%",
          width: "35vw",
          height: "35vw",
          background: isdark === "light"
            ? "radial-gradient(circle, rgba(99, 102, 241, 0.18) 0%, rgba(255,255,255,0) 70%)"
            : "radial-gradient(circle, rgba(99, 102, 241, 0.22) 0%, rgba(11,15,25,0) 70%)",
          borderRadius: "50%",
          zIndex: 0,
          animation: "driftOrb1 12s ease-in-out infinite",
          filter: "blur(40px)"
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "10%",
          right: "10%",
          width: "40vw",
          height: "40vw",
          background: isdark === "light"
            ? "radial-gradient(circle, rgba(236,72,153,0.15) 0%, rgba(255,255,255,0) 70%)"
            : "radial-gradient(circle, rgba(236,72,153,0.18) 0%, rgba(11,15,25,0) 70%)",
          borderRadius: "50%",
          zIndex: 0,
          animation: "driftOrb2 15s ease-in-out infinite",
          filter: "blur(40px)"
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "60%",
          left: "5%",
          width: "25vw",
          height: "25vw",
          background: isdark === "light"
            ? "radial-gradient(circle, rgba(16,185,129,0.12) 0%, rgba(255,255,255,0) 70%)"
            : "radial-gradient(circle, rgba(16,185,129,0.15) 0%, rgba(11,15,25,0) 70%)",
          borderRadius: "50%",
          zIndex: 0,
          animation: "driftOrb1 9s ease-in-out infinite",
          filter: "blur(40px)"
        }}
      />

      {/* Floating Accounting / Math Symbols with different delay and animations */}
      <div className="floating-symbol" style={{ top: "12%", left: "10%", fontSize: "3.5rem", color: "#6366f1", animation: "floatSymbolFast 5s ease-in-out infinite" }}>₹</div>
      <div className="floating-symbol" style={{ top: "68%", left: "18%", fontSize: "2.8rem", color: "#ec4899", animation: "floatSymbolSlow 6s ease-in-out infinite" }}>%</div>
      <div className="floating-symbol" style={{ top: "18%", right: "12%", fontSize: "3.2rem", color: "#10b981", animation: "floatSymbolSlow 4.5s ease-in-out infinite" }}>$</div>
      <div className="floating-symbol" style={{ top: "72%", right: "15%", fontSize: "3rem", color: "#f59e0b", animation: "floatSymbolFast 5.5s ease-in-out infinite" }}>+</div>
      <div className="floating-symbol" style={{ top: "45%", left: "82%", fontSize: "2.5rem", color: "#6366f1", animation: "floatSymbolDrift 7s ease-in-out infinite" }}>-</div>
      <div className="floating-symbol" style={{ top: "48%", left: "6%", fontSize: "2.5rem", color: "#94a3b8", animation: "floatSymbolDrift 8s ease-in-out infinite" }}>=</div>
      <div className="floating-symbol" style={{ top: "25%", left: "30%", fontSize: "2.2rem", color: "#a855f7", animation: "floatSymbolSlow 6.5s ease-in-out infinite" }}>#</div>
      <div className="floating-symbol" style={{ top: "80%", left: "45%", fontSize: "2.4rem", color: "#64748b", animation: "floatSymbolFast 7.5s ease-in-out infinite" }}>÷</div>
      <div className="floating-symbol" style={{ top: "35%", right: "28%", fontSize: "2.2rem", color: "#f43f5e", animation: "floatSymbolDrift 5s ease-in-out infinite" }}>x</div>

      {/* Floating Accounting Icons */}
      <div className="floating-symbol" style={{ top: "8%", left: "55%", fontSize: "2.5rem", color: "#3b82f6", animation: "floatSymbolSlow 9s ease-in-out infinite", opacity: 0.2 }}>📊</div>
      <div className="floating-symbol" style={{ top: "85%", right: "40%", fontSize: "2.3rem", color: "#10b981", animation: "floatSymbolFast 8s ease-in-out infinite", opacity: 0.2 }}>📈</div>
      <div className="floating-symbol" style={{ top: "55%", right: "8%", fontSize: "2.5rem", color: "#f59e0b", animation: "floatSymbolDrift 10s ease-in-out infinite", opacity: 0.2 }}>📉</div>

      {/* Main Card */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          padding: "50px 40px",
          maxWidth: "520px",
          width: "90%",
          background: isdark === "light" ? "rgba(255, 255, 255, 0.75)" : "rgba(17, 24, 39, 0.75)",
          backdropFilter: "blur(20px)",
          borderRadius: "30px",
          border: isdark === "light" ? "1px solid rgba(255, 255, 255, 0.8)" : "1px solid rgba(255, 255, 255, 0.05)",
          boxShadow: isdark === "light"
            ? "0 20px 40px rgba(0, 0, 0, 0.05)"
            : "0 20px 50px rgba(0, 0, 0, 0.5)",
          animation: "fadeInUp 0.6s ease-out forwards",
        }}
      >
        {/* Animated Accounts Balance Scale Illustration */}
        <div style={{ position: "relative", width: "160px", height: "120px", marginBottom: "20px" }}>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 100 80"
            style={{ overflow: "visible" }}
          >
            {/* Base Pillar */}
            <path d="M48 70 L52 70 L52 40 L48 40 Z" fill={isdark === "light" ? "#475569" : "#94a3b8"} />
            <path d="M40 70 L60 70 L55 75 L45 75 Z" fill={isdark === "light" ? "#334155" : "#64748b"} />
            <circle cx="50" cy="40" r="4" fill={isdark === "light" ? "#1e293b" : "#cbd5e1"} />

            {/* Swingable Beam (The scale bar) */}
            <g style={{ animation: "scaleSwing 4s ease-in-out infinite", transformOrigin: "50px 40px" }}>
              <line x1="15" y1="40" x2="85" y2="40" stroke={isdark === "light" ? "#475569" : "#94a3b8"} strokeWidth="3" />

              {/* Left Scale Pan Assembly */}
              <g style={{ animation: "leftPan 4s ease-in-out infinite", transformOrigin: "15px 40px" }}>
                <line x1="15" y1="40" x2="5" y2="55" stroke={isdark === "light" ? "#64748b" : "#64748b"} strokeWidth="1" />
                <line x1="15" y1="40" x2="25" y2="55" stroke={isdark === "light" ? "#64748b" : "#64748b"} strokeWidth="1" />
                <path d="M2 55 L28 55 A 13 13 0 0 1 2 55" fill="#6366f1" />
                {/* Coins on Left Pan */}
                <circle cx="12" cy="53" r="2.5" fill="#f59e0b" />
                <circle cx="17" cy="53" r="2.5" fill="#fbbf24" />
                <circle cx="15" cy="50" r="2.5" fill="#f59e0b" />
              </g>

              {/* Right Scale Pan Assembly (Lighter, unbalanced) */}
              <g style={{ animation: "rightPan 4s ease-in-out infinite", transformOrigin: "85px 40px" }}>
                <line x1="85" y1="40" x2="75" y2="55" stroke={isdark === "light" ? "#64748b" : "#64748b"} strokeWidth="1" />
                <line x1="85" y1="40" x2="95" y2="55" stroke={isdark === "light" ? "#64748b" : "#64748b"} strokeWidth="1" />
                <path d="M72 55 L98 55 A 13 13 0 0 1 72 55" fill="#ec4899" />
                {/* Empty / Lighter coins on Right Pan */}
                <circle cx="85" cy="53" r="2.5" fill="#fbbf24" />
              </g>
            </g>
          </svg>
        </div>

        {/* Status indicator */}
        <div style={{
          fontSize: "14px",
          fontWeight: "700",
          textTransform: "uppercase",
          letterSpacing: "2px",
          color: "#ef4444",
          marginBottom: "10px",
          background: "rgba(239, 68, 68, 0.1)",
          padding: "4px 12px",
          borderRadius: "50px",
          display: "inline-block"
        }}>
          ⚠️ Entry Out of Balance
        </div>

        <h1
          style={{
            fontSize: "26px",
            fontWeight: "800",
            margin: "0 0 12px 0",
            color: isdark === "light" ? "#0f172a" : "#f8fafc",
            letterSpacing: "-0.5px",
            lineHeight: "1.2"
          }}
        >
          404: No Match Found
        </h1>

        <p
          style={{
            fontSize: "15px",
            lineHeight: "1.6",
            color: isdark === "light" ? "#475569" : "#94a3b8",
            marginBottom: "30px",
            maxWidth: "380px"
          }}
        >
          This transaction route cannot be reconciled. The page you are looking for has not been credited to our ledger.
        </p>

        <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
          <button
            className="go-back-btn btn-secondary-custom"
            onClick={handleGoBack}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "13px 24px",
              fontSize: "15px",
              fontWeight: "600",
              color: isdark === "light" ? "#475569" : "#cbd5e1",
              background: isdark === "light" ? "#e2e8f0" : "#334155",
              border: "none",
              borderRadius: "50px",
              cursor: "pointer",
              outline: "none",
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            Reconcile & Go Back
          </button>

          <button
            className="go-back-btn btn-primary-custom"
            onClick={handleGoHome}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "13px 24px",
              fontSize: "15px",
              fontWeight: "600",
              color: "#ffffff",
              background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
              border: "none",
              borderRadius: "50px",
              cursor: "pointer",
              outline: "none",
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};
